module.exports = __webpack_public_path__ + "static/media/SCR-A-new6.358c9b9a.mp3";